export default __webpack_public_path__ + "static/media/cs6.5fb18fe4.jpg";